import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/login.vue'
import Index from './views/idx/index.vue'
import Layout from './components/header.vue'
import utils from './utils/utils.js'

Vue.use(Router)

// 解决ElementUI导航栏中重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const constRouter = [
  {
    path: '/',
    component: Layout
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/indexFull',
    name: 'indexFull',
    component: Index
  }
]
let asyncRouteData = JSON.parse(sessionStorage.getItem('menuData')) || []
asyncRouteData = utils.findTree(asyncRouteData, 3)

let routesData = [
  {
    path: '/home',
    name: 'home',
    component: Layout,
    children: []
  }
]

asyncRouteData.forEach(item => {
  routesData[0].children.push({
    path: `/${item.menuId}`,
    name: item.menuId,
    component: () => import(`./views${item.pageUrl}.vue`)
  })
})

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constRouter
  })

const router = createRouter()
// router.addRoutes(routesData)
routesData.forEach(item => router.addRoute(item))

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  let isLogin = sessionStorage.getItem('token')
  // console.log('beforeRoute', to, from)
  if (isLogin) {
    next()
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
